module.exports = __webpack_public_path__ + "img/80A6B4_D5E9EF_B2D0D9_C1DCE4-256px.b77f2029.png";